module.exports = __webpack_public_path__ + "img/stamp-island-name-icons-melody.1fad67bf.png";